import { render, staticRenderFns } from "./BracketDisplay.vue?vue&type=template&id=03d92074&scoped=true&"
import script from "./BracketDisplay.vue?vue&type=script&lang=js&"
export * from "./BracketDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BracketDisplay.vue?vue&type=style&index=0&id=03d92074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d92074",
  null
  
)

export default component.exports